<div class="assign-dialog">
  <div class="assign-header">
    <ls-avatar-atom [label]="initials()"></ls-avatar-atom>
    <div class="assign-header__info">
      <div class="assign-header__name-row">
        <span class="assign-header__name">{{ fullName }}</span>
        <span class="assign-header__role">{{
          getRoleLabel(userData.role)
        }}</span>
      </div>
      <small class="text-color-secondary">{{ userData.email }}</small>
    </div>
    <button type="button" class="assign-header__close" (click)="close()">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <input
    type="text"
    pInputText
    placeholder="Buscar instalación..."
    class="assign-search w-full"
    [(ngModel)]="searchInstallation" />

  <section class="assign-list">
    <form [formGroup]="formInstallationAssigned">
      <div formArrayName="installations">
        @for (installation of installations.controls; track
        installationTrackBy($index, installation)) { @if
        (matchesSearch(installation)) {
        <div
          [formGroupName]="$index"
          class="installation-row"
          [class.installation-row--assigned]="
            installation.get('isAssigned')?.value
          ">
          <i class="ph-duotone ph-buildings installation-row__icon"></i>
          <div class="installation-row__info">
            <span class="installation-row__name">{{
              installation.get('data')?.value.name
            }}</span>
            <small class="installation-row__company">{{
              installation.get('data')?.value.empresa
            }}</small>
          </div>
          <div class="installation-row__actions">
            <button
              type="button"
              class="installation-row__channel"
              [class.installation-row__channel--active]="
                isChannelActive(installation, 1)
              "
              [disabled]="!installation.get('isAssigned')?.value"
              (click)="toggleChannel(installation, 1)">
              <i class="ph-duotone ph-envelope-simple"></i>
            </button>
            <button
              type="button"
              class="installation-row__channel"
              [class.installation-row__channel--active]="
                isChannelActive(installation, 2)
              "
              [disabled]="!installation.get('isAssigned')?.value"
              (click)="toggleChannel(installation, 2)">
              <i class="ph-duotone ph-chat-text"></i>
            </button>
            <p-toggleswitch
              formControlName="isAssigned"
              (onChange)="toggleAssigned($event, installation)">
            </p-toggleswitch>
          </div>
        </div>
        } }
      </div>
    </form>
  </section>

  <div class="assign-footer">
    <span
      >Acceso a <strong>{{ assignedInstallationCount }}</strong> de
      <strong>{{ installations.length }}</strong> instalaciones</span
    >
    <ls-button-icon-atom
      label="Guardar"
      icon="pi pi-check"
      severity="primary"
      (onClick)="close()"></ls-button-icon-atom>
  </div>
</div>
